import { PropTypes } from 'prop-types';
import React from 'react';
import Radios from '@atoms/Radios';
import { ConnectionsStrings, toCheckboxOrRadioOptions } from '@general/helpers/SavedSearchesQuestionStrings';

export const Connections = ({ values }) => (
    <div>
        <Radios
            label="Select the type of person you are looking to connect with"
            name="connections.connectionType"
            value={values.connections.connectionType}
            instructions="Select one."
            options={toCheckboxOrRadioOptions(ConnectionsStrings.connectionType)}
            required
        />
    </div>
);

Connections.propTypes = {
    values: PropTypes.object,
};
